import { render } from "./createPriceTableConfigComponent.vue?vue&type=template&id=0157ced1&scoped=true"
import script from "./createPriceTableConfigComponent.vue?vue&type=script&lang=js"
export * from "./createPriceTableConfigComponent.vue?vue&type=script&lang=js"

import "./createPriceTableConfigComponent.vue?vue&type=style&index=0&id=0157ced1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0157ced1"]])

export default __exports__